import { render } from "./ControlBox.vue?vue&type=template&id=1773f10d"
import script from "./ControlBox.vue?vue&type=script&lang=js"
export * from "./ControlBox.vue?vue&type=script&lang=js"
script.render = render

export default script